import { Component, computed, Input, input, InputSignal } from '@angular/core';
import * as Highcharts from 'highcharts';
import { HighchartsChartModule } from 'highcharts-angular';
import { CommonModule } from '@angular/common';
import { BarChartConfig } from '@services/analytics-services/hight-chart-configurations/bar-high-chart-config';
import { PieChartConfig } from '@services/analytics-services/hight-chart-configurations/pie-high-chart-config';
import { ChartOptions } from '@services/analytics-services/hight-chart-configurations/high-chart-config';

/**
 * Chart type enum
 */
export type ChartType = 'bar' | 'pie';

@Component({
  selector: 'app-high-chart-container',
  standalone: true,
  imports: [CommonModule, HighchartsChartModule],
  templateUrl: './high-chart-container.component.html',
  styleUrl: './high-chart-container.component.scss',
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }
    `,
  ],
})
export class HighChartContainerComponent {
  @Input() headingTitle: string = '';
  @Input() subtitle: string = '';
  // Inputs converted to signals
  chartOptions: InputSignal<ChartOptions | undefined> = input<ChartOptions | undefined>(undefined);
  chartType: InputSignal<ChartType> = input<ChartType>('bar');
  title: InputSignal<string> = input('');

  Highcharts: typeof Highcharts = Highcharts;

  // Computed signal for final Highcharts options
  readonly finalOptions = computed(() => {
    const baseOptions = this.chartOptions();
    const type = this.chartType();

    // If no options provided, return minimal configuration
    if (!baseOptions) {
      return {
        chart: {
          type: type,
        },
        series: [
          {
            type: type,
            data: [],
          },
        ],
      };
    }

    const chartConfig = {
      chart: {
        type: type,
      },
      title: {
        text: null as any,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {},
    };

    switch (type) {
      case 'pie':
        return PieChartConfig.getPieChartOptions({
          ...baseOptions,
          ...chartConfig,
        });
      default:
        return BarChartConfig.getBarChartOptions({
          ...baseOptions,
          ...chartConfig,
        });
    }
  });
}
